import loader from '../assets/loader.gif'

function ProcessingModal() {

    return(
        <div className="flex justify-center items-center bg-black p-8 fixed top-0 left-0 right-0 bottom-0 h-screen w-screen bg-opacity-50 z-30">
            <div className="text-center text-white">
                <div className='flex w-full justify-center'><img src={loader} width={'50px'} height={'50px'} /></div>
                <div className="text-md font-semibold mt-2">Processing Payment...</div>
                <div className="text-sm">Please do not hit the back button</div>
            </div>
        </div>
    )
}

export default ProcessingModal;